import { RotateCcw } from 'lucide-react';
import * as React from 'react';
import styled from 'styled-components';
import { BooleanColors, booleanColorsOf } from '../../containers_v2/map/colorScale';
import { FlexDiv } from '../../containers_v2/products/style';
import { Dot } from '../../styles/global/css/Dot';
import { translateToString } from '../../styles/global/translate';
import { HexField, IconButton, Label, Swatch } from './style';

// The editor of a boolean column's map colours: one for true, one for
// false. Nothing set means the map's historical green and red, and the
// reset goes back to it.

const ValueLabel = styled(Label)`
	width: 48px;
`;

export default function BooleanColorsEditor(props: { colors: BooleanColors | undefined, onChange: (colors: BooleanColors | undefined) => void }) {
	const colors = booleanColorsOf({ boolean_colors: props.colors });
	const setColor = (key: keyof BooleanColors, color: string) => props.onChange({ ...colors, [key]: color });

	return <FlexDiv flow='column' align='stretch' gap='8px'>
		<FlexDiv justify='flex-end'>
			<IconButton type='button' title={translateToString('color_scale.reset')} onClick={() => props.onChange(undefined)}><RotateCcw size={14} /></IconButton>
		</FlexDiv>
		{(['true', 'false'] as const).map(key => <FlexDiv key={key} gap='8px'>
			<Dot color={colors[key]} size='10px' />
			<ValueLabel>{translateToString(key)}</ValueLabel>
			<Swatch type='color' value={colors[key]} onChange={e => setColor(key, e.target.value.toUpperCase())} />
			<HexField color={colors[key]} onChange={color => setColor(key, color)} />
		</FlexDiv>)}
	</FlexDiv>;
}
